<!--
  name : 김혜진
  desc : 전자계약 홈-푸터
  date : 2021-01-06
-->
<template>
  <v-footer no-gutter>
    <v-col
      class="text-center"
      cols="12"
    >
      Copyright ⓒ BusinessOn Communication Co., Ltd. All rights reserved.
    </v-col>
  </v-footer>
</template>
<script>
export default {
  name: 's-footer',
  components: {
  },
  filters: {
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>